<template lang="pug">
form(@submit.prevent="onFilter")
  .columns.align-center
    .column.col-auto(
      v-if="isEnabledFilter('concluido_em_gteq') || initializePeriodo"
    )
      .pb-1
        small {{ filters.concluido_em_gteq }}
        datepicker(
          v-model="q.concluido_em_gteq",
          placeholder="Conclusãos início",
          input-class="form-input input-sm"
        )
    .column.col-auto(
      v-if="isEnabledFilter('concluido_em_lteq') || initializePeriodo"
    )
      .pb-1
        small {{ filters.concluido_em_lteq }}
        datepicker(
          v-model="q.concluido_em_lteq",
          full-day,
          placeholder="Conclusãos final",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('created_at_gteq')")
      .pb-1
        small {{ filters.created_at_gteq }}
        datepicker(
          v-model="q.created_at_gteq",
          placeholder="Data início",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('created_at_lteq')")
      .pb-1
        small {{ filters.created_at_lteq }}
        datepicker(
          v-model="q.created_at_lteq",
          placeholder="Data final",
          full-day,
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('numero_eq')")
      .pb-1
        small {{ filters.numero_eq }}
        int.form-input.input-sm(v-model="q.numero_eq")
    .column.col-auto(v-if="isEnabledFilter('ano_eq')")
      .pb-1
        small {{ filters.ano_eq }}
        year.form-input.input-sm(v-model="q.ano_eq")
    .column.col-auto(v-if="isEnabledFilter('cadastro_id_eq')")
      .pb-1
        small {{ filters.cadastro_id_eq }}
        cadastro-picker(v-model="q.cadastro_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('contribuinte_cpf_cnpj_eq')")
      .pb-1
        small {{ filters.contribuinte_cpf_cnpj_eq }}
        input-cpf-cnpj.form-input.input-sm(
          v-model="q.contribuinte_cpf_cnpj_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('protocolo_tipo_eq')")
      .pb-1
        small {{ filters.protocolo_tipo_eq }}
        select-protocolo-tipo.select-sm(v-model="q.protocolo_tipo_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('protocolo_numero_eq')")
      .pb-1
        small {{ filters.protocolo_numero_eq }}
        input.form-input.input-sm(v-model="q.protocolo_numero_eq")
    .column.col-auto(v-if="isEnabledFilter('protocolo_ano_eq')")
      .pb-1
        small {{ filters.protocolo_ano_eq }}
        input.form-input.input-sm(v-model="q.protocolo_ano_eq")
    .column.col-auto(v-if="isEnabledFilter('cadastro_zona_eq')")
      .pb-1
        small {{ filters.cadastro_zona_eq }}
        input.form-input.input-sm(
          type="tel",
          v-model="q.cadastro_zona_eq",
          placeholder="Ex: 07"
        )
    .column.col-auto(v-if="isEnabledFilter('cadastro_quadra_eq')")
      .pb-1
        small {{ filters.cadastro_quadra_eq }}
        input.form-input.input-sm(
          type="tel",
          v-model="q.cadastro_quadra_eq",
          placeholder="Ex: 123"
        )
    .column.col-auto(v-if="isEnabledFilter('cadastro_lote_eq')")
      .pb-1
        small {{ filters.cadastro_lote_eq }}
        input.form-input.input-sm(
          type="tel",
          v-model="q.cadastro_lote_eq",
          placeholder="Ex: 1234"
        )
    .column.col-auto.tooltip.tooltip-bottom(
      v-if="isEnabledFilter('assunto_compartilhado_eq')",
      data-tooltip="Com outros departamentos"
    )
      .pb-1
        small {{ filters.assunto_compartilhado_eq }}
        select.form-select.select-sm(v-model="q.assunto_compartilhado_eq", sm)
          option(:value="undefined") Todos
          option(:value="true") Sim
          option(:value="false") Não
    .column.col-auto(v-if="isEnabledFilter('assunto_id_eq')")
      .pb-1
        small {{ filters.assunto_id_eq }}
        assunto-picker(v-model="q.assunto_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('usuario_responsavel_id_eq')")
      .pb-1
        small {{ filters.usuario_responsavel_id_eq }}
        fiscal-picker(v-model="q.usuario_responsavel_id_eq", sm)
    .column.col-auto(
      v-if="isEnabledFilter('usuario_responsavel.usuario_grupo_id_in')"
    )
      .pb-1
        small {{ filters["usuario_responsavel.usuario_grupo_id_in"] }}
        usuario-grupos-picker(
          v-model="q['usuario_responsavel.usuario_grupo_id_in']",
          sm
        )
    .column.col-auto(v-if="isEnabledFilter('usuario_id_eq')")
      .pb-1
        small {{ filters.usuario_id_eq }}
        fiscal-picker(v-model="q.usuario_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('comentario_situacao_id_eq')")
      .pb-1
        small {{ filters.comentario_situacao_id_eq }}
        comentario-situacao-picker(v-model="q.comentario_situacao_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('situacao_eq')")
      .pb-1
        small {{ filters.situacao_eq }}
        select.form-select.select-sm(v-model="q.situacao_eq")
          option Todas
          option(
            v-for="(situacao, key) in $options.filters.translate('enums.db.enum_ordem_servico_situacao')",
            :value="key"
          )
            | {{ situacao }}
    .column.col-auto(v-if="isEnabledFilter('cadastro_id_null')")
      .pb-1
        small &nbsp;
        label.form-checkbox
          input(
            type="checkbox",
            v-model="q.cadastro_id_null",
            @change="onToggleCadastroIdNull"
          )
          i.form-icon
          | {{ filters.cadastro_id_null }}
    .column.col-auto.mt-2.pt-2.no-print
      button.mt-2.btn.btn-action.s-circle.btn-sm(type="submit")
        i.fa.fa-filter
      a.mt-2.ml-2.btn.btn-action.s-circle.btn-sm.no-print(
        onclick="window.print()"
      )
        i.fa.fa-print
    .column.col-auto.mt-2.pt-2.no-print
      enabled-filters.mt-1(
        :localStorageKey="filterKey",
        :defaultEnabledFilters="defaultEnabledFilters",
        :enabledFilters="enabledFilters",
        :filters="filters",
        :query="q",
        :setEnabledFilters="setEnabledFilters"
      )
</template>

<script>
import filterMixin from "@/mixins/filter"

export default {
  mixins: [filterMixin],
  props: {
    filterKey: { type: String, default: "osm-filters" },
    initializePeriodo: { type: Boolean, default: false },
  },
  data() {
    return {
      filters: {
        created_at_gteq: "Data início",
        created_at_lteq: "Data fim",
        cadastro_zona_eq: this.$options.filters.tModel("cadastro.zona"),
        cadastro_quadra_eq: this.$options.filters.tModel("cadastro.quadra"),
        cadastro_lote_eq: this.$options.filters.tModel("cadastro.lote"),
        concluido_em_gteq: "Data conclusão início",
        concluido_em_lteq: "Data conclusão fim",
        assunto_id_eq: this.$options.filters.tModel("assunto"),
        usuario_responsavel_id_eq: this.$options.filters.tModel(
          "ordem_servico.usuario_responsavel",
        ),
        "usuario_responsavel.usuario_grupo_id_in": "Grupos de usuário",
        situacao_eq: this.$options.filters.tModel("ordem_servico.situacao"),
        comentario_situacao_id_eq: this.$options.filters.tModel(
          "ordem_servico.comentario_situacao",
        ),
        numero_eq: this.$options.filters.tModel("ordem_servico.numero"),
        ano_eq: this.$options.filters.tModel("ordem_servico.ano"),
        cadastro_id_eq: this.$options.filters.tModel("cadastro"),
        cadastro_id_null: "Apenas avulsas",
        contribuinte_cpf_cnpj_eq: this.$options.filters.tModel(
          "contribuinte.cpf_cnpj",
        ),
        protocolo_tipo_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_tipo",
        ),
        protocolo_numero_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_numero",
        ),
        protocolo_ano_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_ano",
        ),
        assunto_compartilhado_eq: "Assunto compartilhado",
        usuario_id_eq: this.$options.filters.tModel("ordem_servico.usuario"),
      },
      q: {},
      defaultEnabledFilters: ["created_at_gteq", "created_at_lteq"],
    }
  },
  methods: {
    subDate(days) {
      if (days === "*") return null
      const d = new Date()
      const date = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate() - Number(days),
        0,
        0,
        0,
        0,
      )

      return date.toJSON()
    },
    onFilter() {
      this.$emit("submit", this.q)
    },
    onToggleCadastroIdNull() {
      if (!this.q.cadastro_id_null) this.$delete(this.q, "cadastro_id_null")
    },
  },
  created() {
    if (this.initializePeriodo) {
      this.q = {
        concluido_em_gteq: this.subDate(30),
        concluido_em_lteq: new Date(
          new Date().setUTCHours(23, 59, 59, 999),
        ).toJSON(),
      }
      this.onFilter()
    }
  },
}
</script>
